import React from 'react'
import { useSelector } from 'react-redux'
import { Dropdown } from 'sfy-react'

const CountryDropdown = React.forwardRef(
  (
    {
      classes,
      placeholder,
      selectedCountry,
      handleOnCountrySelection,
      CountryValueComponent,
      CountryOptionComponent,
      isDisabled,
      error = '',
      children,
      labelFloat,
      searchText,
      showDownArrow,
      downArrow,
    },
    ref
  ) => {
    const translatedData = useSelector((state) => state.common.translatedData)
    const appConfigDetails = useSelector((state) => state.common.appConfigDetails)

    return (
      <>
        <Dropdown
          reference={ref}
          customDownArrow={downArrow}
          id='country-dropdown'
          value={selectedCountry}
          classObject={classes}
          placeholder={placeholder || translatedData.common.searchByText}
          handleOnChange={(item) => {
            handleOnCountrySelection(item)
          }}
          options={
            appConfigDetails?.countries?.length
              ? appConfigDetails.countries.map((countryObj) => ({
                  ...countryObj,
                  label: countryObj.countryName,
                  value: countryObj.countryName,
                }))
              : []
          }
          ValueComponent={CountryValueComponent}
          OptionsComponent={CountryOptionComponent}
          filterBy='CountryName'
          searchText={searchText || translatedData.common.search}
          isDisabled={isDisabled}
          labelFloat={labelFloat}
          showDownArrow={showDownArrow}
        >
          {children}
        </Dropdown>
        {error && (
          <div className={`input__message error`} style={{ marginLeft: 'auto' }}>
            {error}
          </div>
        )}
      </>
    )
  }
)

export default CountryDropdown
